<template>
    <div class="about-join">
        <div class="aboutUP-top">
            <i v-if="showType">
                <router-link to="/mine">
                    <img src="../../../static/images/shootShop/back.png" />
                </router-link>
            </i>
            <i v-else></i>
            <h3>加盟租铺宝</h3>
        </div>
        <div class="join-info">
            <div class="join-item">
                <div class="title">一、 租铺宝介绍</div>
                <p
                    class="paragraph"
                >租铺宝为优铺旗下大数据驱动的全价值链商铺交易平台，于2018年4月正式上线运营，目前已经在北京、上海、广州、深圳、成都、重庆、天津、济南、沈阳等15座城市布局，成功服务近万名客户，收录真实商铺近40万套，平台累计用户突破50万。</p>
                <p
                    class="paragraph"
                >租铺宝自运营以来，通过大数据、云计算、AI等前沿技术与商铺租赁交易更好的融合，依托真实海量的品牌、商户、店主、房东资源，公开透明的交易原则，专业精准的匹配服务，重构商铺租赁体验，提高商铺租赁效率。</p>
                <img src="../../../static/images/aboutUP/sm.png" alt class="introduce-img" />
                <div class="title">租铺宝发展历程</div>
                <img src="../../../static/images/aboutUP/times.png" alt class="times" />
            </div>
            <div class="join-item">
                <div class="title">二、加盟条件</div>
                <p class="paragraph">1、面向全国所有的省会城市、地级市开放加盟。</p>
                <p
                    class="paragraph"
                >2、城市合伙人必须具有商业地产基因。即有从事商业地产策划、销售、招商、运营、渠道经纪等专业度，且公司在当地具有一定品牌、规模和影响力。</p>
                <p
                    class="paragraph"
                >3、城市合伙人在当地具有商业地产服务经验和团队，对行业转型与互联网创新具有一定的实践经验和学习、探索意愿，有敢于争先的创业勇气。</p>
                <p
                    class="paragraph"
                >4、加盟不仅仅是业务合作，更是打造命运共同体；不是为了生存，更是为了发展；不是只经营企业，而是要站在行业潮头，不断学习、勇于实践，开放胸怀，分享利益。</p>
            </div>
            <div class="join-item">
                <div class="title">三、加盟支持</div>
                <ul class="lists">
                    <li class="li-item">
                        <img src="../../../static/images/aboutUP/j1.png" alt class="item-img" />
                        <p class="paragraph">精准流量，告别缺房少客的困境，为加盟商提供高转化率的房客资源。</p>
                        <p class="paragraph">实现房源和客源更精准的匹配，提高成交效率，提升客户满意度。</p>
                        <p class="paragraph">基于人才、科技以及流程，显著提高运营支持效率、为合作伙伴降低管理成本和经营成本。</p>
                    </li>
                    <li class="li-item">
                        <img src="../../../static/images/aboutUP/j2.png" alt class="item-img" />
                        <p class="paragraph">优铺品牌授权增信品质背书，让合作伙伴商如虎添翼。</p>
                        <p class="paragraph">中国房地产经理人联盟资源输出，社群活动落地，提升行业影响力。</p>
                    </li>
                    <li class="li-item">
                        <img src="../../../static/images/aboutUP/j3.png" alt class="item-img" />
                        <p class="paragraph">招聘培训，提供人才专业度，解决人才短缺难题。</p>
                        <p class="paragraph">资深专家团队全程指导，通过业务拆解、业务辅导、数据报表、产品运营等策略，将方法论转化为具体行动方案。</p>
                        <p class="paragraph">制定品质标准，确保房源的真实有效、从业人员的规范操作，完善。</p>
                        <p class="paragraph">“安心保障”服务承诺并确保有效执行，提升用户体验。</p>
                    </li>
                    <li class="li-item">
                        <img src="../../../static/images/aboutUP/j4.png" alt class="item-img" />
                        <p class="paragraph">开放商圈字典系统、客源管理系统、交易管理系统，实现统一管理和应用， 确保信息品质。</p>
                        <p class="paragraph">制定合作规则，保护合作网络中的独家角色，依据角色合理分佣。</p>
                        <p class="paragraph">基于丰富的经验和资源，为合作伙伴提供便捷、高效的交易支持，降低交易风险 。</p>
                        <p class="paragraph">“安心保障”服务承诺并确保有效执行，提升用户体验。</p>
                    </li>
                </ul>
            </div>
            <div class="join-item">
                <div class="title">四、加盟流程</div>
                <img src="../../../static/images/aboutUP/lc.png" alt class="join-lc" />
            </div>
            <div class="join-item">
                <div class="title">五、收费标准</div>
                <img src="../../../static/images/aboutUP/fy.png" alt class="join-fy" />
            </div>
            <div class="join-item">
                <div class="title">六、加盟咨询</div>
                <div class="tel">
                    <span class="name">联系人：畅媛媛</span>
                   <!-- <span>联系电话：177-1059-6763</span> -->
                </div>
                <div class="tel">咨询热线：010-85951005</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      showType: true,
      move:''
    }
  },
  mounted(){
    //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        var request = new Object();
        request = GetRequest();

        this.move = request['move']; 
        if(this.move == "android"){
            $(".aboutUP-top").hide();
            $(".about-join").css({ "padding-top": "0rem" });
        }
  }
};
</script>

<style scoped lang="scss">
.about-join {
  padding-top: 1rem;
  background: #fff;
  overflow: hidden;
  .aboutUP-top {
    width: 7.5rem;
    height: 1rem;
    text-align: center;
    background: #fff;
    border-bottom: 0.02rem solid #eee;
    position: fixed;
    top: 0;
    z-index: 1000000;
    h3 {
      width: 75%;
      line-height: 1rem;
      font-size: 0.36rem;
      color: #333;
      float: left;
      text-align: center;
    }
    i {
      display: inline-block;
      width: 13%;
      height: 1rem;
      line-height: 1rem;
      float: left;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      img {
        width: 0.22rem;
        height: 0.37rem;
      }
    }
  }
  .join-info {
    padding: 0 0.3rem .5rem;
    box-sizing: border-box;
    .join-item {
      .title {
        margin: 0.6rem 0 0.3rem;
        font-size: 0.28rem;
        color: #0f1923;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .paragraph {
        font-size: 0.26rem;
        color: #0f1923;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0.5rem;
      }
      .introduce-img {
        width: 5.8rem;
        height: 5.7rem;
        margin-top: 0.4rem;
      }
      .times {
        width: 4.91rem;
        height: 12.11rem;
      }
      .lists {
        .li-item {
          margin-bottom: 0.4rem;
          .item-img {
            width: 1.9rem;
            height: 0.55rem;
            margin-bottom: 0.3rem;
          }
        }
      }
      .join-lc {
        width: 6.24rem;
        height: 3.48rem;
        display: block;
        margin: 0 auto;
      }
      .join-fy {
        width: 6.9rem;
        height: 2.08rem;
      }
      .tel{
          color: #2D4E8A;
          font-size: .24rem;
          font-weight: 500;
          font-family:PingFang SC;
          .name{
              margin-right: .5rem;
          }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mine/aboutJoin.vue